export const CheckIcon01 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='8' viewBox='0 0 10 8' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.60002 0.200059C10.0418 0.53143 10.1314 1.15823 9.80002 1.60006L5.30002 7.60006C5.13411 7.82127 4.884 7.96391 4.60914 7.99409C4.33427 8.02426 4.05918 7.93927 3.84923 7.75932L0.349227 4.75932C-0.0700991 4.39989 -0.118661 3.76859 0.240762 3.34927C0.600184 2.92994 1.23148 2.88138 1.65081 3.2408L4.34042 5.54619L8.20002 0.400059C8.53139 -0.0417689 9.15819 -0.131312 9.60002 0.200059Z'
        fill='#B2B8C2'
      />
    </svg>
  );
};

export const SelectListCheck = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M13.293 3.29297C13.6835 2.90244 14.3165 2.90244 14.707 3.29297C15.0976 3.68349 15.0976 4.31651 14.707 4.70703L7.20703 12.207C6.81651 12.5976 6.18349 12.5976 5.79297 12.207L1.29297 7.70703C0.902444 7.31651 0.902444 6.68349 1.29297 6.29297C1.68349 5.90244 2.31651 5.90244 2.70703 6.29297L6.5 10.0859L13.293 3.29297Z'
        fill='#24272C'
      />
    </svg>
  );
};
